import React from 'react';

function SoulthAfrica(props) {
  return (
    <svg
      width="36"
      height="24"
      viewBox="0 0 36 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_800_123955)">
        <mask
          id="mask0_800_123955"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="36"
          height="24"
        >
          <rect width="36" height="24" fill="white" />
        </mask>
        <g mask="url(#mask0_800_123955)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0H36V24H0V0Z"
            fill="#F7FCFF"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0V8H36V0H0Z"
            fill="#E31D1C"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 16V24H36V16H0Z"
            fill="#3D58DB"
          />
          <mask
            id="path-6-outside-1_800_123955"
            maskUnits="userSpaceOnUse"
            x="-2"
            y="-6"
            width="40"
            height="36"
            fill="black"
          >
            <rect fill="white" x="-2" y="-6" width="40" height="36" />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M17.3571 10L0 -2V26L17.3571 14H36V10H17.3571Z"
            />
          </mask>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.3571 10L0 -2V26L17.3571 14H36V10H17.3571Z"
            fill="#5EAA22"
          />
          <path
            d="M0 -2L1.13736 -3.64512L-2 -5.81416V-2H0ZM17.3571 10L16.2198 11.6451L16.7331 12H17.3571V10ZM0 26H-2V29.8142L1.13736 27.6451L0 26ZM17.3571 14V12H16.7331L16.2198 12.3549L17.3571 14ZM36 14V16H38V14H36ZM36 10H38V8H36V10ZM-1.13736 -0.354885L16.2198 11.6451L18.4945 8.35489L1.13736 -3.64512L-1.13736 -0.354885ZM2 26V-2H-2V26H2ZM16.2198 12.3549L-1.13736 24.3549L1.13736 27.6451L18.4945 15.6451L16.2198 12.3549ZM36 12H17.3571V16H36V12ZM34 10V14H38V10H34ZM17.3571 12H36V8H17.3571V12Z"
            fill="#F7FCFF"
            mask="url(#path-6-outside-1_800_123955)"
          />
          <path
            d="M0.5547 5.16795L-1 4.13148V6V18V19.8685L0.5547 18.8321L9.5547 12.8321L10.8028 12L9.5547 11.1679L0.5547 5.16795Z"
            fill="#272727"
            stroke="#FECA00"
            strokeWidth="2"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_800_123955">
          <rect width="36" height="24" rx="5" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default SoulthAfrica;
